import { componentFactory } from '../../../fc-core/src/lib';
import NumericAxis from '../../../fc-core/src/axis/numeric';
import CategoryAxis from '../../../fc-core/src/axis/category';
export default function (a) {
  var b,
      c,
      d = a.getChildren('canvas')[0],
      f = d.getChildren('axisRefVisualCartesian')[0],
      e = {
    zoomable: !0,
    pannable: !0
  },
      g = a._feedAxesRawData(),
      h = function h(a) {
    var b = a.sender;
    f.addexplicitDrawItems(b.getId(), b), f.asyncDraw();
  };

  componentFactory(a, NumericAxis, 'yAxis', 1, g.yAxisConf), componentFactory(a, CategoryAxis, 'xAxis', 1, g.xAxisConf), b = a.getChildren('yAxis')[0], c = a.getChildren('xAxis')[0], b.setLinkedItem('canvas', d), c.setLinkedItem('canvas', d), f.setLinkedItem(b.getId(), b), f.setLinkedItem(c.getId(), c), f.addExtEventListener('visiblerangeset', h, c), f.addExtEventListener('visiblerangeset', h, b), d.attachAxis(c, !1, a.zoomX ? e : {}), d.attachAxis(b, !0, a.zoomY ? e : {}), a._setCategories();
}